import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class Modal2Service {
    openModalByIdSubject = new Subject<string>();

    openModalById(id: string) {
        this.openModalByIdSubject.next(id);
    }
}
